var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDropout48Line = function SvgIconDropout48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.81 12.19A16.604 16.604 0 0 0 24 7.3c-4.46 0-8.65 1.74-11.81 4.89C9.03 15.34 7.3 19.54 7.3 24c0 4.46 1.74 8.65 4.89 11.81 3.15 3.16 7.35 4.89 11.81 4.89 4.46 0 8.65-1.74 11.81-4.89 3.16-3.15 4.89-7.35 4.89-11.81 0-4.46-1.74-8.65-4.89-11.81ZM14.6 33.4c-2.51-2.51-3.9-5.85-3.9-9.4 0-2.98.98-5.8 2.78-8.12l18.64 18.64A13.231 13.231 0 0 1 24 37.3c-3.55 0-6.89-1.38-9.4-3.9Zm19.93-1.29L15.88 13.48c2.32-1.79 5.14-2.78 8.12-2.78 3.55 0 6.89 1.38 9.4 3.9 2.51 2.51 3.9 5.85 3.9 9.4 0 2.98-.98 5.8-2.78 8.12l.01-.01Z",
    fill: "current"
  })));
};
export default SvgIconDropout48Line;